/**
 * ContentObjectRegistryService is a service class that manages the registration and retrieval of content objects.
 * It maintains two main collections: one for registered objects and another for registered content grouped by IDs.
 */
class ContentObjectRegistryService {
    /**
     * Constructs the ContentObjectRegistryService instance.
     * @param {Object} $bridges - The service bridge providing access to other services.
     */
    constructor($bridges) {
        'ngInject';
        this.$bridges = $bridges;
        this._logIdentifier = 'ContentObjectRegistryService';
        this.$logger = this.$bridges.logger();
        this._registeredContent = {}; // Stores content grouped by IDs.
        this._registeredObj = {}; // Stores individual objects by their types.
    }

    /**
     * Registers an object with its properties.
     * @param {Array} obj - The object to be registered.
     * @param {Object} objProperties - The properties of the object.
     */
    register(obj, objProperties) {
        // Store the object by its type.
        this._registeredObj[obj[0].objectType] = {
            obj: obj[0],
            objProperties: objProperties
        };

        // Link the object to its properties.
        objProperties.obj = obj;
        // Initialize the group if it doesn't exist.
        if (typeof this._registeredContent[objProperties.group.id] === 'undefined') {
            this._registeredContent[objProperties.group.id] = {
                group: objProperties.group,
                objProperties: []
            };
        }
        // Insert the object properties at the beginning of the list.
        this._registeredContent[objProperties.group.id].objProperties.unshift(objProperties);
    }

    /**
     * Retrieves the registered content, optionally hiding response objects.
     * @param {boolean} hideResponseObj - Flag to hide response objects.
     * @returns {Array} - The registered content.
     */
    registeredContent(hideResponseObj) {
        if (typeof hideResponseObj !== "undefined" && hideResponseObj === true) {
            var result = [];
            // Iterate over each group of registered content.
            Object.keys(this._registeredContent).forEach(key => {
                const value = this._registeredContent[key];
                const filteredObjProperties = value.objProperties.filter(obj => typeof obj.isResponse === "undefined" || obj.isResponse === false);
                result.push({
                    group: value.group,
                    objProperties: filteredObjProperties
                });
            });
            return result;
        } else {
            return Object.assign({}, this._registeredContent);
        }
    }

    /**
     * Retrieves the properties of an object by its type.
     * @param {string} type - The type of the object.
     * @returns {Object} - The properties of the object.
     */
    getObjectProperties(type) {
        return this._registeredObj[type];
    }
}

// Add explicit dependency injection
ContentObjectRegistryService.$inject = ['$bridges'];

export default ContentObjectRegistryService;